import _ from "lodash"
import { useState, useEffect } from "react"
import { _getNextNewsList } from "../../libraries/common";
import { LatestNewsItem, NewsItem } from '@/components/news';
import { HeaderBack } from '@/components/common/header';
import { EmptyData } from '@/components/common/emptyData';
import { pageLimit } from "../../config/site";
import { InView } from "react-intersection-observer";
import { LoadMore } from '@/components/common/loader';
import { Footer } from "../common/footer";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";

export const VehicleNews = (props) => {
    const { t, device, session, fetchedData, type = 1, params } = props;

    // news list
    const [totalRow, setTotalRow] = useState(0);
    const [newsList, setNewsList] = useState([]);
    const [offset, setOffset] = useState(0);
    const [isLoadingNewsList, setIsLoadingNewList] = useState(true)

    useEffect(()=>{
        const fetchData = async() => {
            try {
                setIsLoadingNewList(true)
                await _getNextNewsList({offset: 0, limit: pageLimit, vehicle_model_id: fetchedData?.vehicle_model_id, type: type}, setNewsList, setTotalRow)
                setOffset(0)
            } catch(error) {
                console.log(error)
            } finally {
                setIsLoadingNewList(false)
            }
        }
        
        fetchData()
    },[])

    const _handleLoadMore = async(inView, entry) => {
        if(inView == true && isLoadingNewsList == false){
            setIsLoadingNewList(true)
            await _getNextNewsList({offset: offset + pageLimit, limit: pageLimit, vehicle_model_id: fetchedData?.vehicle_model_id, type: type}, setNewsList, setTotalRow)
            setOffset((prev)=>prev + pageLimit)
            setIsLoadingNewList(false)
        }
    }

    return (
        <>
            {
                params?.vehicle?.[2] == "news" &&
                <>
                    <AllMeta
                        title={t('vehicleBrandModelNewsPage_meta_title', { brandModel: fetchedData?.name })}
                        description={t('vehicleBrandModelNewsPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: fetchedData?.name })}
                        keyword={t('vehicleBrandModelNewsPage_meta_keyword', { brandModel: fetchedData?.name})}
                        image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
                        imageWidth={1275}
                        imageheight={666}
                    />
                    <Head><title>{t('vehicleBrandModelNewsPage_title', {brandModel: fetchedData?.name})}</title></Head>
                </>
            }
            {
                params?.vehicle?.[2] == "video" &&
                <>
                    <AllMeta
                        title={t('vehicleBrandModelVideoPage_meta_title', { brandModel: fetchedData?.name })}
                        description={t('vehicleBrandModelVideoPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: fetchedData?.name })}
                        keyword={t('vehicleBrandModelVideoPage_meta_keyword', { brandModel: fetchedData?.name})}
                        image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
                        imageWidth={1275}
                        imageheight={666}
                    />
                    <Head><title>{t('vehicleBrandModelVideoPage_title', {brandModel: fetchedData?.name})}</title></Head>
                </>
            }
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack 
                        t={t}
                    />
                }
            >
                {/* TODOS vehicleNews can remove or not */}
                <div className="vehicleNews containerPadding">
                    <p className="fontSize_20 fontWeight_bold">
                        {`${fetchedData?.name} ${type == 1 ? t("news") : t("video")}`}
                    </p>
                </div>
                {
                    !_.isEmpty(newsList) ? <LatestNewsItem data={newsList?.[0]} type={newsList?.[0]?.type} /> : null 
                }
                {
                    !_.isEmpty(newsList) ?
                        _.reduce(newsList, (result, value, key) => {
                            key >= 1 ? 
                            result.push(
                                <div key={key}>
                                    <NewsItem data={value} type={value?.type} />
                                </div> 
                            )
                            :
                            null
                            return result
                        },[])
                        :
                    null
                }
                {
                    _.isEmpty(newsList) &&
                    <EmptyData t={t} isLoading={isLoadingNewsList} />
                }
                {/* {
                    totalRow > (offset + pageLimit) &&
                    <InView as="div" onChange={_handleLoadMore} threshold={0.2}>
                        <LoadMore t={t} />
                    </InView>
                } */}
                {
                    (totalRow > (offset + pageLimit) && isLoadingNewsList == false) &&
                    <InView as="div" onChange={_handleLoadMore}>
                        {/* <LoadMore t={t} /> */}
                    </InView>
                }
                {
                    (totalRow > (offset + pageLimit) && isLoadingNewsList == true) &&
                    <LoadMore t={t} />
                }
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         {
    //             params?.vehicle?.[2] == "news" &&
    //             <>
    //                 <AllMeta
    //                     title={t('vehicleBrandModelNewsPage_meta_title', { brandModel: fetchedData?.name })}
    //                     description={t('vehicleBrandModelNewsPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: fetchedData?.name })}
    //                     keyword={t('vehicleBrandModelNewsPage_meta_keyword', { brandModel: fetchedData?.name})}
    //                     image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
    //                     imageWidth={1275}
    //                     imageheight={666}
    //                 />
    //                 <Head><title>{t('vehicleBrandModelNewsPage_title', {brandModel: fetchedData?.name})}</title></Head>
    //             </>
    //         }
    //         {
    //             params?.vehicle?.[2] == "video" &&
    //             <>
    //                 <AllMeta
    //                     title={t('vehicleBrandModelVideoPage_meta_title', { brandModel: fetchedData?.name })}
    //                     description={t('vehicleBrandModelVideoPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: fetchedData?.name })}
    //                     keyword={t('vehicleBrandModelVideoPage_meta_keyword', { brandModel: fetchedData?.name})}
    //                     image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
    //                     imageWidth={1275}
    //                     imageheight={666}
    //                 />
    //                 <Head><title>{t('vehicleBrandModelVideoPage_title', {brandModel: fetchedData?.name})}</title></Head>
    //             </>
    //         }
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'>
    //                 <HeaderBack 
    //                     t={t}
    //                 />
    //                 <div className="vehicleNews containerPadding">
    //                     <p className="fontSize_20 fontWeight_bold">
    //                         {`${fetchedData?.name} ${type == 1 ? t("news") : t("video")}`}
    //                     </p>
    //                 </div>
    //                 {
    //                     !_.isEmpty(newsList) ? <LatestNewsItem data={newsList?.[0]} type={newsList?.[0]?.type} /> : null 
    //                 }
    //                 {
    //                     !_.isEmpty(newsList) ?
    //                         _.reduce(newsList, (result, value, key) => {
    //                             key >= 1 ? 
    //                             result.push(
    //                                 <div key={key}>
    //                                     <NewsItem data={value} type={value?.type} />
    //                                 </div> 
    //                             )
    //                             :
    //                             null
    //                             return result
    //                         },[])
    //                         :
    //                     null
    //                 }
    //                 {
    //                     _.isEmpty(newsList) &&
    //                     <EmptyData t={t} isLoading={isLoadingNewsList} />
    //                 }
    //                 {/* {
    //                     totalRow > (offset + pageLimit) &&
    //                     <InView as="div" onChange={_handleLoadMore} threshold={0.2}>
    //                         <LoadMore t={t} />
    //                     </InView>
    //                 } */}
    //                 {
    //                     (totalRow > (offset + pageLimit) && isLoadingNewsList == false) &&
    //                     <InView as="div" onChange={_handleLoadMore}>
    //                         {/* <LoadMore t={t} /> */}
    //                     </InView>
    //                 }
    //                 {
    //                     (totalRow > (offset + pageLimit) && isLoadingNewsList == true) &&
    //                     <LoadMore t={t} />
    //                 }
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </>
    // )
}